import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-circle-info",
  "use": "icon-circle-info-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-circle-info\"><path d=\"M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm1 9.75v4.5c0 .414-.448.75-1 .75s-1-.336-1-.75v-4.5c0-.414.448-.75 1-.75s1 .336 1 .75zM13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol